import classNames from 'classnames'
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useHistory } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { IconButton, Theme } from '@mui/material'

export type UserHeaderBackButtonProps = ExtendableStyles & Testable

export function CorporateHeaderBackButton({ className, style }: UserHeaderBackButtonProps) {
  const { classes } = useStyles()
  const history = useHistory()
  return (
    // TODO: this assumes that we will always come from the list view page, otherwise going "back" will cause an unexpected UX.
    <IconButton className={classNames(className, classes.backButton)} style={style} onClick={() => history.goBack()}>
      <ArrowLeftIcon className={classes.fillParent} />
    </IconButton>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  backButton: {
    position: 'relative',
    width: spacing(6),
    height: spacing(6),
  },
  fillParent: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
}))
